// extracted by mini-css-extract-plugin
export default {"wrapButton":"style_wrapButton__PmceX","submit":"style_submit__Zt+2Q","submit_press":"style_submit_press__VxWQB"};